import type { pwaEn } from './pwa-en.ts';

type DeepString<T> = T extends string ? string : { [K in keyof T]: DeepString<T[K]> };

/** Italian strings of the installed web app. Typed against the English shape. */
export const pwaIt: DeepString<typeof pwaEn> = {
  pwa: {
    updateReady: 'È pronta una versione nuova del gioco.',
    update: 'Aggiorna',
    later: 'Più tardi',
    offlineReady:
      'Il gioco è salvato su questo dispositivo: Solista, Allenamento e Tutorial funzionano senza rete.',
    install: 'Installa l’app',
    installNote: 'Si apre dalla schermata iniziale o dal desktop, in una finestra tutta sua.',
    installed: 'L’app è installata.',
  },
};
